import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=6ef2f7e8"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports